import { getContentEditableDiv1 } from './getRole';
import latestReleases from '../helpers/versions/latestReleases';

export const getTextBox = () => ({
  object: 'text',
  leaves: [{ text: '' }],
});

export default (params) => {
  const { preTag } = params;

  let documentData = {};
  let nodes;
  const data = {
    toExport: true,
  };

  /**
   * Conditionally define the nodes inside skills details
   *
   * * NOTE: Define any new node as a get function, if required
   */

  if (
    preTag === 'objective' ||
    preTag === 'letter_body' ||
    preTag === 'summary'
  ) {
    const { componentKey } = params;
    documentData = {
      ...documentData,
      version: {
        number: latestReleases[componentKey],
        updated: true,
      },
    };
    nodes = [{ ...getContentEditableDiv1(preTag), data }];
  }

  return {
    document: {
      data: { ...documentData },
      nodes,
    },
  };
};
